import React, { Component } from 'react';
import Select from 'react-select';
import { AddRevenue } from '../../Redux/action/revenueAction';
import { toast } from 'react-toastify';
import {
  allLocationWithShortName,
  dataLocation,
  dataUser,
  spocLocationDetailsZoho,
} from '../Helpers/util';
import './form.css';
import moment from 'moment';
import axios from 'axios';
import { getLocationNameById } from '../../utils/getLocationNameById';
import SwInput from '../Common/FormComponent/SwInput';
import SwTextArea from '../Common/FormComponent/SwTextArea';
import SwRadio from '../Common/FormComponent/SwRadio';
import SwCheckbox from '../Common/FormComponent/SwCheckbox';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);
const userDataLocal12 = spocLocationDetailsZoho();
const locationWithShortName = allLocationWithShortName();

class DailyShuttleServiceRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: UserObj ? UserObj.company_id : null,
      spocid: UserObj ? UserObj.rec_id : null,
      email: UserObj ? UserObj.email : '',
      notes: '',
      locationSpoc: [],
      location: '',
      location1: '',
      locationError: '',
      locationData: [],
      locationNew: [],
      locationId: null,
      isModalOpen: true,

      shift: null,
      selectedServices: [], // Array to store selected services
      otherServiceDescription: '', // State to store text input value
      noOfPeopleError: '',
      noOfPeople: '',
      shiftError: '',
      requiredServiceError: '',
      files: null,
      attachmentError: '',
      btnStatus: false,
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: '',
      isCheckedOther: false,
    };
    this.inputRef = React.createRef();
  }

  componentDidMount() {
    var LocationSpoc = JSON.parse(userDataLocal12);
    let locationShort = JSON.parse(locationWithShortName);
    this.setState({ locationNew: locationShort });
    this.setState({
      locationData: LocationSpoc,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isCheckedOther && !prevState.isCheckedOther) {
      if (this.inputRef.current) {
        this.inputRef.current.focus();
      }
    }
  }

  changeSelect = e => {
    if (!e) {
      this.setState({
        location: null,
        location1: '',
        locationId: '',
        locationError: '',
      });
      return;
    }

    this.setState({
      location: e,
      location1: String(e.label),
      locationId: e.value,
      locationError: '',
    });
  };

  handleShiftChange = event => {
    this.setState({ shift: event.target.value });
  };
  handleCheckboxChange = event => {
    const { value, checked } = event.target;

    this.setState(prevState => {
      const updatedServices = checked
        ? [...prevState.selectedServices, value]
        : prevState.selectedServices.filter(service => service !== value);

      return {
        selectedServices: updatedServices,
        isCheckedOther: value === 'Other' ? checked : prevState.isCheckedOther,
      };
    });
  };

  options1 = [
    { value: 'Day', label: 'Day' },
    { value: 'Night', label: 'Night' },
  ];

  onNotes = e => {
    this.setState({
      notes: e?.target?.value,
      notesError: '',
    });
  };
  resetValue = () => {
    this.setState({
      location: '',
      notes: '',
      locationError: '',
      notesError: '',
      noOfPeople: '',
      shift: '',
      selectedServices: '', // Include selected checkbox data
      otherServiceDescription: '',
      attachmentError: '',
    });
    this.setState({
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: '',
    });
  };

  onLocation = e => {
    this.setState({
      location: e?.target?.value,
      location1: String(e.value),
      locationError: '',
    });
  };

  handleTextInputChange = event => {
    this.setState({ otherServiceDescription: event.target.value });
  };

  handleFile(e) {
    if (e.target.files[0]) {
      this.setState({
        selectedFile: e.target.files[0],
        selectedFileName: e.target.files[0].name,
        imageSrc: window.URL.createObjectURL(e.target.files[0]),
        value: e.target.value,
      });
    }

    // Getting the files from the input
    this.setState({ files: e.target.files });

    if (e.target.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    } else if (e.target.files.length <= 2) {
      this.setState({ attachmentError: '' });
    }
  }
  handleModalClose = () => {
    this.setState({ isModalOpen: false });
  };

  handleSubmit = e => {
    e.preventDefault();

    const {
      location,
      shift,
      selectedServices,
      noOfPeople,
      otherServiceDescription,
      notes,
      files,
    } = this.state;

    // Validation logic for the form fields
    if (location === '') {
      this.setState({ locationError: "Location can't be empty" });
      return;
    }
    if (!noOfPeople || isNaN(noOfPeople) || noOfPeople <= 0) {
      this.setState({
        noOfPeopleError: 'No Of People must be a positive number',
      });
      return;
    }
    if (!shift) {
      toast.error('Shift can not be empty');
      return;
    }
    if (!selectedServices.length) {
      toast.error('Required Service can not be empty');
      return;
    }
    e.currentTarget.disabled = true;

    // Construct the API payload


    let param = {};
    let common_param = {
      company_id: UserObj ? UserObj.company_id : null,
      spoc_id: UserObj ? UserObj.rec_id : null,
      email: UserObj ? UserObj.email : null,
      category: 'daily_shuttle',
      company_name: UserObj ? UserObj.company_name : null,
    };
    let body_param = {
      location_name: location,
      no_of_people: noOfPeople,
      shift: shift,
      required_service: selectedServices.join(', '),
      other_service_description: otherServiceDescription,
      notes: notes,
    };
    param.common_param = common_param;
    param.body_param = body_param;

    // Make API call (AddRevenue function) and handle success or failure
    // AddRevenue(param, this.props.onClose)
    //   .then(() => {
    //     // success handled by onClose
    //     this.setState({ btnStatus: false });
    //     e.currentTarget.disabled = false;
    //   })
    //   .catch(() => {
    //     // error toast already shown in AddRevenue
    //     this.setState({ btnStatus: false });
    //     e.currentTarget.disabled = false;
    //   });
    // e.currentTarget.disabled = false;

    AddRevenue(param, (success, message) => {
      if (success) {
        toast.success(message);
        this.resetValue();
        if (this.props.onClose) {
          this.props.onClose();
        }
      }
      this.setState({ btnStatus: false });
      e.currentTarget.disabled = false;
    })
  };

  render() {
    const selectLocationData = [];
    if (this.state.locationSpoc && this.state.locationSpoc.length > 0) {
      this.state.locationSpoc.map(item => {
        if (item.rec_id) {
          selectLocationData.push({
            value: item['location_name_zoho'],
            label: item['location_name_zoho'],
          });
        }
      });
    }

    return (
      <>
        {' '}
        <div className="row">
          {' '}
          <div className="col-md-12">
            <div className="SwFormGroup">
              {' '}
              <label className="SwFormLabel">
                Location <span className="Required">*</span>
              </label>{' '}
              <SwSelect
                name="location"
                id="shuttle-location-select"
                onChange={this.changeSelect}
                value={this.state.location}
                options={this.state.locationData}
                isClearable={false}
              />
              <span className="SwTextDanger SwTextSmall">{this.state.locationError}</span>
            </div>
          </div>{' '}
        </div>
        <div className="row">
          <div className="col-md-12">
            {' '}
            <div className="SwFormGroup">
              <label className="SwFormLabel">
                No of People <span className="Required">*</span>
              </label>{' '}
              <SwInput
                type="number"
                id="shuttle-people-input"
                min="0"
                value={this.state.noOfPeople}
                onChange={e =>
                  this.setState({
                    noOfPeople: e.target.value,
                    noOfPeopleError: '',
                  })
                }
              />{' '}
              <span className="SwTextDanger SwTextSmall">{this.state.noOfPeopleError}</span>
            </div>
          </div>{' '}
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="SwFormGroup">
              <label className="SwFormLabel">
                Shift <span className="Required">*</span>
              </label>
              <SwRadio
                id="shuttle-shift-radio1"
                name="customRadio"
                label="Day"
                value="Day"
                checked={this.state.shift === 'Day'}
                onChange={this.handleShiftChange}
              />
              <SwRadio
                id="shuttle-shift-radio2"
                name="customRadio"
                label="Night"
                value="Night"
                checked={this.state.shift === 'Night'}
                onChange={this.handleShiftChange}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="SwFormGroup">
              <label className="SwFormLabel">
                Required Service <span className="Required">*</span>
              </label>
              <SwCheckbox
                id="shuttle-service-checkbox1"
                name="selectedServices"
                label="Point to point pick up and drop"
                value="Point to point pick up and drop"
                checked={this.state.selectedServices.includes(
                  'Point to point pick up and drop',
                )}
                onChange={this.handleCheckboxChange}
              />

              <SwCheckbox
                id="shuttle-service-checkbox2"
                name="selectedServices"
                label="Nodal drops (for eg. office to nearest metro station)"
                value="Nodal drops (for eg. office to nearest metro station)"
                checked={this.state.selectedServices.includes(
                  'Nodal drops (for eg. office to nearest metro station)',
                )}
                onChange={this.handleCheckboxChange}
              />

              <SwCheckbox
                id="shuttle-service-checkbox3"
                name="selectedServices"
                label="Other"
                value="Other"
                checked={this.state.isCheckedOther}
                onChange={this.handleCheckboxChange}
              />

              {this.state.isCheckedOther && (
                <div className="row">
                  <div className="col-md-12">
                    <SwInput
                      placeholder="Describe"
                      value={this.state.otherServiceDescription}
                      onChange={this.handleTextInputChange}
                      ref={this.inputRef}
                      id="shuttle-isChecked-input"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 mt-2">
            <div className="SwFormGroup">
              {' '}
              <label className="SwFormLabel">Notes</label>{' '}
              <SwTextArea
                rows="4"
                id="shuttle-notes"
                value={this.state.notes}
                onChange={this.onNotes}
              />{' '}
            </div>
          </div>{' '}
        </div>{' '}
      </>
    );
  }
}

export default DailyShuttleServiceRequest;
